import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import appConfig from '@nerdwallet/app-config';
import { Link as RRLink } from 'react-router-dom';

import classes from '@nerdwallet/base-styles/classes';
import Link from '@nerdwallet/react-link';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
const SectionNavigation = ({ navItems, currentSlug, className }) => {
  if (!navItems.length > 0) {
    return null;
  }

  const renderLinks = (items = [], level = 0) => {
    if (!items.length > 0) {
      return null;
    }

    const links = items.map((link) => {
      if (!link.title || !link.slug) {
        return null;
      }

      const isCurrent = link.slug === currentSlug;
      const isSubLevel = level > 0;

      // Set target to force an external link
      const linkTarget = link.outbound ? '_blank' : null;

      const linkProps = {
        target: linkTarget,
        color: 'neutral-darkest',
        unstyled: true,
      };

      // Does the slug contain a fully qualified URL?
      const isExternal = link.slug.search(/^https?:\/\//) > -1;
      const trkParams = '?trk=nw_ra_leftRail';

      // Construct the URL from the vertical path (if internal) and slug
      if (isExternal) {
        linkProps.href = `${link.slug}${trkParams}`;
      } else {
        linkProps.component = RRLink;
        linkProps.to = `${appConfig.BASE_URI}/${link.verticalPath}/${link.slug}${trkParams}`;
      }

      return (
        <li
          key={link.slug}
          className={classNames([
            'section-navigation__sub-item',
            `level-${level}`,
            { current: isCurrent },
          ])}
        >
          <Link {...linkProps}>
            <div
              className={classNames([
                'section_navigation__link',
                classes([
                  'display-block',
                  'padding-all-2',
                  { bold: isCurrent || !isSubLevel },
                ]),
              ])}
            >
              {link.title}
            </div>
          </Link>

          {link.children &&
            link.children.length > 0 &&
            renderLinks(link.children, level + 1)}
        </li>
      );
    });

    return <ul>{links}</ul>;
  };

  return (
    <nav
      role="navigation"
      className={classNames(['section-navigation', className])}
    >
      {renderLinks(navItems)}
    </nav>
  );
};

SectionNavigation.displayName = 'SectionNavigation';

SectionNavigation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  navItems: PropTypes.array,
  currentSlug: PropTypes.string,
  className: PropTypes.string,
};

export default SectionNavigation;
